import { registerQuery } from 'data-fetching-client';
import { getGrowthFeaturesWithDefaultsNoAuthRpc, getTranslatedGrowthFeaturesFromProductsRpc } from 'feature-store-service-types';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getEarlyRequestResult } from '../utils/earlyRequest';
import { transformGetFeaturesWithDefaultsResponse } from './dataTransformer';
export const GET_FEATURES_BY_API_NAMES = registerQuery({
  fieldName: 'features',
  args: ['productApiNames', 'i18nLangLocale'],
  fetcher({
    productApiNames,
    i18nLangLocale
  }) {
    const rpcClient = createRpcClientV2({
      hubHttpClient: noAuthHttp
    });
    return rpcClient.call(getTranslatedGrowthFeaturesFromProductsRpc, {
      queryParameters: {
        productApiNames,
        i18nLangLocale
      }
    });
  }
});
export const GET_FEATURES_WITH_DEFAULTS = registerQuery({
  fieldName: 'featuresWithDefaults',
  args: ['i18nLangLocale', 'earlyRequestName'],
  fetcher({
    i18nLangLocale,
    earlyRequestName
  }) {
    const rpcClient = createRpcClientV2({
      hubHttpClient: noAuthHttp
    });
    return getEarlyRequestResult(earlyRequestName, () => {
      return rpcClient.call(getGrowthFeaturesWithDefaultsNoAuthRpc, {
        pathParameters: {
          i18nLangLocale
        }
      });
    }).then(response => {
      return transformGetFeaturesWithDefaultsResponse(response);
    });
  }
});